"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Connected24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "connected-24", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M14.5,20 C12.362,20 10.513,18.777 9.603,16.995 C13.663,16.939 16.94,13.663 16.995,9.603 C18.777,10.513 20,12.361 20,14.5 C20,17.538 17.538,20 14.5,20 M4,9.5 C4,6.462 6.462,4 9.5,4 C11.639,4 13.487,5.223 14.397,7.005 C10.337,7.06 7.061,10.337 7.005,14.397 C5.223,13.487 4,11.638 4,9.5 M15,9.5 C15,12.538 12.538,15 9.5,15 C9.339,15 9.181,14.989 9.024,14.976 C9.011,14.819 9,14.661 9,14.5 C9,11.462 11.462,9 14.5,9 C14.661,9 14.819,9.011 14.976,9.024 C14.989,9.181 15,9.339 15,9.5 M16.677,7.323 C15.744,4.243 12.885,2 9.5,2 C5.358,2 2,5.358 2,9.5 C2,12.885 4.243,15.744 7.323,16.677 C8.256,19.757 11.115,22 14.5,22 C18.642,22 22,18.642 22,14.5 C22,11.115 19.757,8.256 16.677,7.323", id: "Page-1", fill: "#000000" })));
}
function Connected24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Connected24Svg, Object.assign({}, svgProps)));
}
exports.default = Connected24;
//# sourceMappingURL=Connected24.js.map